import Button from "@/components/base/Button";
import { aboutParagraphs } from "@/mocks/site";
import { galleryItems } from "@/data/gallery";

const principles = [
  "Accurate diagnosis before any treatment decision",
  "Clear, honest communication at every visit",
  "A personalised plan built around each patient",
];

/**
 * "Our Story" editorial section — large typography on the left, structured
 * content beside a colourful vertical accent line on the right.
 */
export default function Story() {
  const image = galleryItems[4];

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="reveal lg:col-span-5">
            <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.18em] text-accent-700">
              <span className="h-px w-8 bg-gradient-to-r from-primary-400 to-accent-400" aria-hidden="true"></span>
              Our Story
            </span>
            <h2 className="mt-5 font-heading text-3xl font-semibold leading-[1.12] text-foreground-950 md:text-4xl">
              Specialist Care With a <span className="text-gradient-brand">Patient-First</span> Approach
            </h2>
            <div className="mt-8 overflow-hidden rounded-2xl border border-background-200 bg-background-100">
              <div className="h-[260px] w-full md:h-[320px]">
                <img
                  src={image.image}
                  alt={image.alt}
                  title={`${image.title} — Ortho Spine Care, Trichy`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="reveal relative lg:col-span-7 lg:pl-12">
            <span
              className="absolute left-0 top-1 hidden h-[calc(100%-1rem)] w-1 rounded-full bg-gradient-to-b from-primary-500 via-secondary-500 to-accent-500 lg:block"
              aria-hidden="true"
            ></span>
            <div className="space-y-5 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
              {aboutParagraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 32)}>{paragraph}</p>
              ))}
            </div>

            <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((item) => (
                <li key={item} className="flex items-start gap-3 rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className="ri-check-line text-sm" aria-hidden="true"></i>
                  </span>
                  <span className="font-body text-sm text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Button to="/services" size="lg" icon="ri-stethoscope-line">
                Explore Our Services
              </Button>
              <Button to="/about#specialist" variant="outline" size="lg" icon="ri-user-heart-line">
                Meet Our Doctor
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}